import Vue from 'vue'
import { NETWORKS_CODES } from '@/utils/constants/networks'

export const myShop = {
    state: {
        status: 'idle',
        myShop: null,
        availableNetworks: [NETWORKS_CODES.EURO, NETWORKS_CODES.ABC, NETWORKS_CODES.GROSZEK],
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        filters: {
            merchantIds: {
                type: 'ui-virtual-list',
                value: [],
                multi: !true,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getMyShopLocationsByAvailableNetworks',
                disabledLinkGenerator: true
            }
        }
    },
    mutations: {
        SET_MYSHOP_STATUS(state, payload) {
            state.status = payload
        },
        SET_MYSHOP(state, payload) {
            state.myShop = payload
        },
        SET_MYSHOP_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_MYSHOP_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        }
    },
    actions: {
        myShopFetch({ commit, state, getters }) {
            commit('SET_MYSHOP_STATUS', 'loading')

            const params = getters.getMyShopQueryParams

            return this.$api
                .get('reports/my_shop', {
                    params
                })
                .then(res => {
                    if (res?.data?.data) {
                        commit('SET_MYSHOP', res.data.data.images)
                    } else {
                        commit('SET_MYSHOP', null)
                    }
                    commit('SET_MYSHOP_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_MYSHOP_STATUS', 'idle')
                    }
                })
        },
        setMyShopDefaultMerchant({ commit, getters }) {
            const merchant = getters.getMyShopLocationsByAvailableNetworks[0]

            if (merchant) {
                commit('SET_MYSHOP_FILTER', {
                    filter: 'merchantIds',
                    value: merchant.value
                })
            }
        }
    },
    getters: {
        getMyShop: state => {
            return state.myShop
        },
        getMyShopStatus: state => {
            return state.status
        },
        getMyShopQueryParams: (state, getters) => {
            const crmId = getters.getMerchantById(
                state.filters.merchantIds.value
                // eslint-disable-next-line camelcase
            )?.crm_id
            return {
                merchant_id: state.filters.merchantIds.value,
                crm_id: crmId
            }
        },
        getMyShopFilters: state => {
            return state.filters
        },
        getMyShopLocationsByAvailableNetworks: (state, getters) => {
            return state.availableNetworks.flatMap(network =>
                getters.getMerchantsByNetworkAlias(network)
            )
        }
    }
}
